import { FC, useContext } from "react";
import { AppCtx } from "src/contexts/app.context";
import IdealIconBackground from "src/icons/IdealIconBackground";
import BancontactIconBackground from "src/icons/BancontactIconBackground";
import VisaIconBackground from "src/icons/VisaIconBackground";
import MaestroIconBackground from "src/icons/MaestroIconBackground";
import MasterCardIconBackground from "src/icons/MasterCardIconBackground";
import AmexIconBackground from "src/icons/AmexIconBackground";
import GPayIconBackground from "src/icons/GPayIconBackground";
import PaypalIconBackground from "src/icons/PaypalIconBackground";
import Przelewy24IconBackground from "src/icons/Przelewy24IconBackground";
import DiscoverIconBackground from "src/icons/DiscoverIconBackground";
import DinersClubIconBackground from "src/icons/DinersClubIconBackground";
import ApplePayIconBackground from "src/icons/ApplePayIconBackground";
import SofortIconBackground from "src/icons/SofortIconBackground";
import KlarnaIconBackground from "src/icons/KlarnaIconBackground";

import { Wrapper } from "./PaymentMethodsInfo.styled";
import { usePspMollieEnabled } from "src/hooks/usePspMollieEnabled";
import { canHandleApplePay } from "src/utils/applepay/applePayHelper";

const PaymentMethodsInfo: FC = () => {
  const { locale } = useContext(AppCtx);

  const isMollieEnabled = usePspMollieEnabled();

  return (
    <Wrapper>
      {["nl", "nl-be"].includes(locale) && <IdealIconBackground />}
      {["nl", "nl-be"].includes(locale) && <BancontactIconBackground />}
      <VisaIconBackground />
      <MaestroIconBackground />
      <MasterCardIconBackground />
      <AmexIconBackground />

      {!isMollieEnabled && <GPayIconBackground />}
      {canHandleApplePay() && <ApplePayIconBackground />}
      <PaypalIconBackground />
      {["nl", "nl-be", "de", "de-at"].includes(locale) && (
        <SofortIconBackground />
      )}
      {locale === "pl-pl" && <Przelewy24IconBackground />}
      {locale === "en-us" && <DiscoverIconBackground />}
      {locale === "en-us" && <DinersClubIconBackground />}
      {locale === "de" && <KlarnaIconBackground />}
    </Wrapper>
  );
};

export default PaymentMethodsInfo;
